// JavaScript client library for accessing the Menus API

import {dispatch} from '../dispatcher';
import moment from 'moment';
import newCommon from '../../utility/common';

const CommonActions = {

  baseUrl: newCommon.baseUrl,

  promiseXHR: function(method, url, params, contentType) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      if ('withCredentials' in xhr) {
        xhr.withCredentials = true;
      }

      xhr.open(method, newCommon.baseUrl + url);
      xhr.setRequestHeader("Accept", "application/json");

      xhr.onerror = function() {
        reject();
      }

      xhr.onload = function() {

        switch (xhr.status) {
          case 400:
          case 401:
          case 404:
          case 500:
            let error = JSON.parse(xhr.responseText);
            error.id = newGuid();  // set a unique identifier for React keying
            dispatch({
              type: 'errors/new',
              error: error
            });

            reject("API Error");
            return;
          default:
            // Continue with normal processing
            break;
        }

        if (xhr.responseText) {
          const data = JSON.parse(xhr.responseText);
          resolve({xhr, data});
        } else {
          resolve({xhr});
        }
      }

      if (params && typeof params ==='object' && !(params instanceof FormData)) {
        xhr.setRequestHeader("Content-Type", "application/json");
        params = JSON.stringify(params);
      }

      if (contentType) {
        xhr.setRequestHeader("Content-Type", contentType);
      }

      xhr.send(params);
    });
  },

  dateToString: function(date) {
    return moment(date).format("YYYY-MM-DD");
  },

  // Gets a GUID from the XHR response Location header.
  // Useful for getting the GUID of a created object.
  getIdFromLocationHeader: function(xhr) {
    const locationHeader = xhr.getResponseHeader('Location');
    const regex = /[0-9A-Fa-f]{8}[-]?(?:[0-9A-Fa-f]{4}[-]?){3}[0-9A-Fa-f]{12}/;
    return regex.exec(locationHeader)[0];
  }
}

function newGuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c === 'x' ? r : ((r & 0x3) | 0x8);
      return v.toString(16);
  });
}

export default CommonActions;